// extracted by mini-css-extract-plugin
export default {"text":"Text_text__jjaxy","white-space--nowrap":"Text_white-space--nowrap__WDekn","white-space--wrap":"Text_white-space--wrap__bxp2B","center":"Text_center__3DemZ"};